var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.71461 1.14258H22.286M1.71118 7.99972H22.2775M1.71461 14.8569H22.2775","stroke":"#423D81","strokeWidth":"1.71429","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Burger.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
